const reviewText = (key, fallback, params = {}) => ({ key, fallback, params })

const reviewFact = (id, label, value) => ({ id, label, value })

const statusFromRuntime = step => {
    if (step.isLoading || step.isSaving) {
        return 'pending'
    }

    if (step.hasValidationResult && !step.isValid) {
        return 'blocked'
    }

    return step.isCompleted ? 'complete' : 'attention'
}

export { reviewFact, reviewText, statusFromRuntime }
